import createImageUrlBuilder from '@sanity/image-url'

const projectId = process.env.NEXT_PUBLIC_SANITY_PROJECT_ID
const dataset = process.env.NEXT_PUBLIC_SANITY_DATASET

const imageBuilder = createImageUrlBuilder({
    projectId: projectId || '',
    dataset: dataset || '',
})

export const urlForImage = (source: any) => {
    // Ensure that source image contains a valid reference
    if (!source?.asset?._ref) {
        return undefined
    }

    return imageBuilder?.image(source).auto('format').fit('max')
}
